/**
 * @param {String} message
 * @return {boolean}
 * @private
 */
var _validErrorMessage = function (message) {
    var m = message;

    try {
        m = m.toLowerCase();
        m = m.trim();

        if (m === 'script error.' || m === 'script error') {
            return false;
        }

        if (m === 'access is denied.' || m === 'access is denied') {
            return false;
        }
    } catch (e) {
        // do nothing
    }

    return true;
};

/**
 * This sets up the window.onerror handler
 *
 * @param {Logger} logger
 */
var setupWindowOnError = function (logger) {
    // add the hook to the onError event
    var _previousOnErrorHandler = window.onerror;

    window.onerror = function (message, source, lineno, colno, error) {
        try {
            if (_validErrorMessage(message)) {
                var errorData = {};

                if (typeof error !== 'undefined' && error !== null) {
                    errorData = logger.parseError(error);
                }

                errorData.exception_message = message;

                if (typeof source !== 'undefined') {
                    errorData.exception_source = source;
                }

                if (typeof lineno !== 'undefined') {
                    errorData.exception_line = lineno;
                }

                if (typeof colno !== 'undefined') {
                    errorData.exception_column = colno;
                }

                logger.error('Uncaught JS Exception', errorData);
            }
        } catch (e) {
            logger.error('onerror exception', e);
        }

        // Call the previous error handler in case someone else is listening
        if (typeof _previousOnErrorHandler === 'function') {
            _previousOnErrorHandler(message, source, lineno, colno, error);
        }

        return false;
    };
};

export { setupWindowOnError };
